// extracted by mini-css-extract-plugin
module.exports = {"container":"Prices_container__Oo0O5","link":"Prices_link__fvEzt","isBold":"Prices_isBold__DFkBp"};